<example>
    <!-- inline /resources/images/svgs/cat.svg -->
    <base-svg name="cat" />
</example>

<script>
    import _ from 'lodash'

    export default {
        props: {
            name: {
                type: String,
                required: true
            }
        },
        created () {
            this.matches = /<svg([^>]+)>(.*)<\/svg>/g.exec(
                require(`../../svg/${this.$props.name}.svg`)
            )
        },
        mounted () {
            this.$el.innerHTML = this.matches[2]
        },
        render (createElement) {
            return createElement('svg', {
                class: `block ${this.name}`,
                attrs: _(this.matches[1].match(/(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?/g))
                    .map(attribute => {
                        const [key, value] = attribute.split(/=(.+)/).splice(0, 2)

                        return [key, _.trim(value, '"')]
                    })
                    .fromPairs()
                    .value()
            })
        }
    }
</script>
